import { ETAT_OBTENU } from '@/configuration/optionBlocage/optionBlocage';
import { LISTE_TYPE_LIGNE, TYPE_COMMANDE } from '@/configuration/devisConf';
import validationDcf from '@/services/devisCommandes/validation/validation';

export default function validation(response, messages, i18n) {
  if (!response.data.error || !response.data.error.validationErrors) {
    return;
  }
  validationDcf(response, messages, true, TYPE_COMMANDE);
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('NOT_FOUND') === 0) {
      messages.push({
        message: 'validationDevis.quotationNotfound',
      });
    }
    if (message.indexOf('NOT_SAVE_STATE') === 0) {
      messages.push({
        message: 'validationDevis.notSaveState',
      });
    }
    if (message.indexOf('CANT_ORDER_WITH_PROSPECT') === 0) {
      messages.push({
        message: 'validationDevis.cantOrderWithProspec',
      });
    }
    if (message.indexOf('NOT_QUOTATION') === 0) {
      messages.push({
        message: 'validationDevis.notQuotation',
      });
    }
    if (message.indexOf('NOT_ORDER') === 0) {
      messages.push({
        message: 'validationDevis.notOrder',
      });
    }
    if (message.indexOf('CANNOT_ORDER_WRONG_STATE_COMMAND_LINE') === 0) {
      const etatObtenu = message.split('|')[0].split('@')[2];
      const etatObtenuTrad = i18n.t(ETAT_OBTENU.find((etat) => {
        return etat.key === etatObtenu;
      }).libelle);
      messages.push({
        message: 'validationDevis.etatObtenu',
        parametres: { etatObtenu: etatObtenuTrad },
      });
    }
    if (message.indexOf('CANNOT_ORDER_WAIT_COMMAND_LINE') === 0) {
      messages.push({
        message: 'validationDevis.waitForOrder',
      });
    }
    if (message.indexOf('ALREADY_ORDERED') === 0) {
      messages.push({
        message: 'validationDevis.partial.alreadyOrdered',
      });
    }
    if (message.indexOf('FORBIDDEN_INSIDE_BUNDLE') === 0) {
      messages.push({
        message: 'validationDevis.partial.insideBundle',
      });
    }
    if (message.indexOf('FORBIDDEN_INSIDE_CUSTOM_BUNDLE') === 0) {
      messages.push({
        message: 'validationDevis.partial.insideCustomBundle',
      });
    }
    if (message.indexOf('LIGNE_COMMANDE_NOT_IN_QUOTATION') === 0) {
      messages.push({
        message: 'validationDevis.partial.notQuotation',
      });
    }
    if (message.indexOf('LIGNE_COMMANDE_WRONG_TYPE') === 0) {
      const typeMess = message.split('|')[0].split('@')[2];
      const typeLigneTrad = i18n.t(LISTE_TYPE_LIGNE.find((type) => {
        return type.code === typeMess;
      }).libelle);
      messages.push({
        message: 'validationDevis.partial.lineWrongType',
        parametres: { typeLigne: typeLigneTrad },
      });
    }
    if (message.indexOf('COMMANDE_LOCKED_CLIENT') === 0) {
      const typeMess = message.split('|')[0].split('@')[1];
      messages.push({
        message: 'validationDevis.lockedClient',
        parametres: { nomCommercial: typeMess },
      });
    }
  });
}
